import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import mi from './locales/mi.json';

/**
 * react-i18next setup.
 *
 * IMPORTANT: te reo Māori translations in mi.json are AI-drafted and require
 * review by a fluent te reo speaker before any user testing — likely a kuia
 * reviewer at NASH or a contract translator. See task #8 for the workforce
 * decision and ADR-001 §9 for the wider context.
 *
 * The fallback language is `mi` (te reo Māori), reflecting the bicultural
 * commitment in the project brief: te reo Māori is the primary language,
 * English is the supported second language. Browser preference still wins
 * when it can be detected and matches one of the supported languages.
 */

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mi: { translation: mi },
    },
    supportedLngs: ['mi', 'en'],
    fallbackLng: 'mi',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'wfp.lang',
    },
  });

export default i18n;
